import { put, select, take, takeLatest } from 'redux-saga/effects';

import { targetUserIdSelector } from '../../../context/selectors';
import { CIRCLE_ACTION_TYPES } from '../../constants';
import * as changeMemberRoleReq from '../../change-member-role-req';
import * as reqCircleOfCare from '../../../board/reqCircleOfCare';
import * as success from '../../../ui/success';

function* changeRoleWorker({ payload }) {
  const { memberId, role } = payload;

  const userId = yield select(targetUserIdSelector);

  yield put(
    changeMemberRoleReq.actions.send({
      memberId,
      userId,
      role,
    }),
  );

  yield take(changeMemberRoleReq.consts.SUCCEED);

  yield put(reqCircleOfCare.actions.send({ id: userId }));

  yield put({
    type: success.consts.UPDATE,
    payload: { id: 'circles.invites.roleChanged' },
  });
}

export default function* circleOfCareActionsSaga() {
  yield takeLatest(CIRCLE_ACTION_TYPES.CHANGE_ROLE, changeRoleWorker);
}



// WEBPACK FOOTER //
// ./src/redux/circles/sagas/circle-of-care/change-role-saga.js